module.exports = __webpack_public_path__ + "img/soft-skills-image-2.27ca964b.jpg";